import classNames from 'classnames'
import { forwardRef } from 'react'
import styles from './index.module.scss'

const CustomMenu = forwardRef<HTMLDivElement, CustomToggleProps>(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    //used screenSize in order to prevent the dropdown menu
    //from getting overlapped with the navbar for certain range of screensizes
    return (
      <div
        ref={ref}
        style={style}
        className={classNames(
          styles.dropdown_menu,
          'zindex-popover',
          className,
          styles.custom_menu_margin
        )}
        aria-labelledby={labeledBy}
      >
        <ul className="p-0 mb-0 text-left d-flex flex-column justify-content-center border-0">
          {children}
        </ul>
      </div>
    )
  }
)

export default CustomMenu
